import { connect } from 'react-redux';

import { MENU } from 'Component/Header/Header.config';
import { CUSTOMER_ACCOUNT_OVERLAY_KEY } from 'Component/MyAccountOverlay/MyAccountOverlay.config';
import { CHECKOUT_URL } from 'Route/Checkout/Checkout.config';
import {
    CartOverlayContainer as SourceCartOverlayContainer,
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps
} from 'SourceComponent/CartOverlay/CartOverlay.container';
import { setCartLoading } from 'Store/Cart/Cart.action';
import { isSignedIn } from 'Util/Auth';
import { scrollToTop } from 'Util/Browser';
import componentLoader from 'Util/componentLoader';
import history from 'Util/History';
import { getProductInStock } from 'Util/Product/Extract';
import { appendWithStoreCode } from 'Util/Url';

export const CartDispatcher = componentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Cart/Cart.dispatcher'
), 2);

// eslint-disable-next-line @scandipwa/scandipwa-guidelines/create-config-files
export const DEBOUNCE_TIME = 100;
/** @namespace Bodypwa/Component/CartOverlay/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    device: state.ConfigReducer.device,
    loading: state.CartReducer.loading,
    headerHeight: state.UiReducer.headerHeight
});
/** @namespace Bodypwa/Component/CartOverlay/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    setCartLoading: (loading) => dispatch(setCartLoading(loading))
});

/** @namespace Bodypwa/Component/CartOverlay/Container */
export class CartOverlayContainer extends SourceCartOverlayContainer {
    containerFunctions = {
        ...this.containerFunctions,
        hideOverlay: this.hideOverlay.bind(this)
    };

    componentDidMount() {
        this.updateCartHeight();
        window.addEventListener('resize', this.debounce(this.updateCartHeight.bind(this), DEBOUNCE_TIME));
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.debounce(this.updateCartHeight.bind(this), DEBOUNCE_TIME));
    }

    debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };

            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    updateCartHeight = () => {
        const { headerHeight } = this.props;
        this.setState({ cartHeight: window.innerHeight - headerHeight });
    };

    hideOverlay() {
        const { hideActiveOverlay, setNavigationState } = this.props;

        hideActiveOverlay();
        setNavigationState({
            name: MENU
        });
    }

    hasOutOfStockProductsInCartItems = (items, isCart = false) => (
        items.some(({ product }) => !getProductInStock(product, product, isCart))
    );

    containerProps() {
        const {
            totals,
            totals: {
                items = []
            } = {},
            showOverlay,
            currencyCode,
            activeOverlay,
            cartTotalSubPrice,
            cartDisplaySettings,
            isMobile,
            cartShippingPrice,
            cartShippingSubPrice,
            loading
        } = this.props;
        const { isEditing, isCartItemLoading, cartHeight } = this.state;
        return {
            totals,
            showOverlay,
            currencyCode,
            activeOverlay,
            cartTotalSubPrice,
            cartDisplaySettings,
            isEditing,
            isMobile,
            cartShippingPrice,
            cartShippingSubPrice,
            isCartItemLoading,
            hasOutOfStockProductsInCart: this.hasOutOfStockProductsInCartItems(items, true),
            loading,
            cartHeight
        };
    }

    handleCheckoutClick(e) {
        const {
            guest_checkout,
            showOverlay,
            showNotification,
            setNavigationState,
            hideActiveOverlay
        } = this.props;

        // to prevent outside-click handler trigger
        e.nativeEvent.stopImmediatePropagation();

        // Guest checkout enabled or user is signed in => proceed to the checkout
        if (guest_checkout || isSignedIn()) {
            hideActiveOverlay();
            history.push({ pathname: appendWithStoreCode(CHECKOUT_URL) });
            scrollToTop();

            return;
        }

        // there is no mobile, as cart overlay is not visible here
        showOverlay(CUSTOMER_ACCOUNT_OVERLAY_KEY);
        showNotification('info', __('Please sign-in to complete checkout!'));
        setNavigationState({ name: CUSTOMER_ACCOUNT_OVERLAY_KEY, title: 'Sign in' });
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CartOverlayContainer);
